import { combineReducers } from 'redux';
import { entitiesReducer, queriesReducer } from 'redux-query';
import { hotelBrandSelectionReducer } from './hotelBrandSelectionReducer';
import { featureFlagsReducer } from './featureFlags/featureFlagsReducer';

const combineRootReducer = combineReducers({
    entities: entitiesReducer,
    queries: queriesReducer,
    hotelBrandSelection: hotelBrandSelectionReducer,
    featureFlags: featureFlagsReducer,
});

export default combineRootReducer;
